<button ibmButton
  *ngIf="authService?.user.canUpgradePlan"
  [routerLink]="['/', 'subscription', 'plans']"
  class="max-width-none my-3"
  [type]="'primary'">
  <strong class="p-3">Get unlimited access to RXN for Chemistry</strong>
</button>